import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { IHistory } from '../../interfaces';
import { UserModel } from '../../model/UserModel';
import { UserModuleModel } from '../../model/UserModulesModel';
import { getAllUserModules } from '../../services/userModuleService';
import { getUserData } from '../../services/utilityServices';
import { parseJwt } from '../../utils/generalUtils';
import { Async } from '../reusableComponents/Async';
import { BasePage } from '../reusableComponents/BasePage';
import { ListPage } from '../reusableComponents/ListPage';
import { Loader } from '../reusableComponents/Loader/Loader';
import { ListItem } from './ListItem';
import './userModules.scss';
import { getAllModules } from '../../services/moduleService';

export interface IUserModuleListPageProps {
    instances: UserModuleModel[];
    history: IHistory;
    userUID: string;
}

export interface IUserModuleListPageState {
    open: boolean;
}

export class UserModuleListPageImpl extends React.PureComponent<IUserModuleListPageProps, IUserModuleListPageState> {
    constructor(props: IUserModuleListPageProps) {
        super(props);
        this.state = { open: false };
    }

    public promise = async () => {
        await getAllUserModules();
        await getAllModules();
    }

    public renderUserModuleList = () => {
        return <ListPage
            instances={this.props.instances}
            listItemComponent={ListItem}
            searchBy={['Id', 'Name', 'modulesCount', '']}
            isSearchable={true}
            searchPlaceHolder="Type name to start search..."
            pageHeadings={['ID', 'Name', 'Modules', 'Options']}
            promise={this.promise}
            cols={[1, 5, 2, 4]}
            emptyListMessage="No User Modules Available"
            chartTitle = "UserModulesList"
        />;
    }

    public handleDeleteListItems = () => {
        this.setState({
            open: true
        });
    }

    public render() {
        return <BasePage title="User Module List" icon="user-tag">
            <Async
                identifier="UserModuleListPage"
                promise={this.promise}
                loader={<Loader type="async" />}
                content={this.renderUserModuleList()}
                error={<Loader type="async" />}
            />
        </BasePage >;
    }
}
export function mapStateToProps(state) {
    const userUID = state.login.get('token') ? parseJwt(state.login.get('token')).UniqueID : getUserData().userUID;
    return {
        userUID,
        instances: UserModuleModel.list(),
        userInstance: UserModel.get(userUID)
    };
}
export const UserModuleListPage = 
withRouter(connect<{}, {}, IUserModuleListPageProps>(mapStateToProps)(UserModuleListPageImpl) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/UserModules/UserModuleListPage.tsx